import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { validateService} from "../service/validation.service";
import { apiService} from "../service/api.service";
import Loader from "../common/Loader";
import { useEffect, useState } from 'react';
import swal from "sweetalert";

const ForgotPassword = () => {
  const [loader,setLoader]=useState(false)
  const [email, setemail] = useState("");
  const [emailErr, setemailErr] = useState();
  let history = useNavigate();

  const forgotPassword = ()=>{
   let valid =  validateService.validateEmail(email,setemailErr)
    if(valid){
      setLoader(true)
      
     apiService.forgotPassword(email).then((res) => {
      setemail("")
  
       swal("Success",res.data.message,"success")
      
      
       setLoader(false)
   }).catch((err) => {
    setLoader(false)
    console.log(err)
    swal("Error",err.response.data.message,"error")
   console.log("contact us api error", err.response);
   });
    }
   }
  return (
    <>
      <section className="login-section">
      {loader && <Loader/>}
        <Container>
          <Row>
            <Col lg={6} md={8}>
              <div className="login-form-box">
                <div className="login-header">
                  <h2>Forgot Password? </h2>
                  <p>Enter the email address associated with your
                    account and we’ll send you a link to reset your
                    password.</p>
                </div>
                <Form className="login-body">
                  <Form.Group className="mb-3">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter Email Address" value={email} onChange={(e)=>setemail(e.target.value)}/>
                    <span className="text-danger">{emailErr}</span>
                  </Form.Group>
                  <Button onClick={forgotPassword} className="green-btn" >Continue</Button>
                  <p>Back to <Link to="/login" className="">Sign In</Link></p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default ForgotPassword;
